/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Cookies\CookieWrapper.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday June 7th 2023 11:35:16 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import CookieInstance from "Cookies/Cookie";

/**
 * Factory to create cookie instance Object
 * @param {Object} target The instance of cookie
 */
const CookieFactory = (target: CookieInstance) => ({
  setCookie: (field: string, data: any, dayMultiplyer: number) => target.setCookie(field, data, dayMultiplyer),
  getCookie: (field: string) => target.getCookie(field),
  removeCookie: (field: string) => target.removeCookie(field),
});

const cookie = CookieFactory(new CookieInstance());

export default cookie;
